export type Id = string | number;

/**
 * An exception class to throw when the ID function is called on a reference type
 */
export class NonPrimitiveIdError extends Error {
  constructor() {
    super("A non-primitive value cannot be converted to an ID");
  }
}

/**
 * Helps handle cases where id=0 vs id=undefined or id=null
 * Works like normal type casting in JavaScript: ID(0)
 * @param id
 */
export default function ID(id: unknown = undefined) {
  if (id == null || id === "") {
    return undefined;
  }

  if (["object", "symbol"].includes(typeof id)) {
    throw new NonPrimitiveIdError();
  }

  return String(id);
}
